import {BASE_URL} from '../config'

export const isHomePath = (pathname) => {
    return ! pathname || pathname === '/' || pathname === BASE_URL || pathname === `${BASE_URL}/`;
}

export const stripBasePath = (pathname) => {
    return pathname.replace(BASE_URL, '');
}


// WEBPACK FOOTER //
// ./src/utils/pages.js